class Pushing {
    constructor(name, context, request) {
        this.name = name;
        this.context = context;
        this.request = request;
        this.state = 'init';
        /**
         * if this pushing is bound to component which dispatched this pushing
         * @type {boolean}
         */
        this.boundToDispatcher = true;
        this.time = new Date();
    }
}

export default Pushing;